__turbopack_context__.v({
  "className": "geist_mono_30bbba1c-module__UqHuTq__className",
  "variable": "geist_mono_30bbba1c-module__UqHuTq__variable",
});
